module.exports = __webpack_public_path__ + "assets/images/collection-empty-8419b52c8e1d8164ab324c4337938c4b.jpg";